<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-radio',
  mixins: [abstractField],
  computed: {
    items() {
      let values = this.schema.values;
      return values;
    }
  },
  methods: {
    onChange($event) {
      this.schema.onChange && this.schema.onChange(this.model, this.schema, $event);
    },
    onInput(val) {
      this.value = val;
    }
  },
  render() {
    const legoRadio = resolveComponent('lego-radio');
    const legoRadioWrapper = resolveComponent('lego-radio-wrapper');
    const legoRadioItem = this.items.map((item, idx) => {
      return h(
        legoRadio,
        {
          modelValue: item,
          id: `${this.schema.id}-${idx}`,
          class: this.schema.fieldClasses,
          disabled: this.schema.disabled,
          name: this.schema.model,
          valueKey: this.schema.valueKey,
          required: this.schema.required
        },
        [item]
      );
    });

    return h(
      legoRadioWrapper,
      {
        checked: this.value,
        modelValue: this.value,
        disabled: this.schema.disabled,
        onClick: this.onChange,
        'onUpdate:modelValue': this.onInput
      },
      [legoRadioItem]
    );
  }
};
</script>
<style lang="scss">
.c-form-group {
  .field-radios {
    padding-top: 6px;
  }
}
</style>
